import React, {useState} from "react";
import BottomSheet from "./BottomSheet";

export default function TabModal({tabs, show, setShow, onClose}) {
    const [activeTab, setActiveTab] = useState(0);

    return <BottomSheet show={show} setShow={setShow} onClose={onClose}>
        <div className="d-flex mb-3">
            {tabs.map((tab, index) => <Tab key={index} label={tab.name} active={activeTab === index} onClick={() => setActiveTab(index)} />)}
        </div>
        {tabs[activeTab].content}
    </BottomSheet>
}

function Tab({
                 label, active, onClick
             }) {
    return (
        <button
            className={`btn ${active ? 'btn-secondary' : 'btn-outline-secondary'}`}
            onClick={onClick}
        >{label}</button>
    );
}
